export const environment = {
  version: '9.2.1',
  production: false,
  sentryDsn: 'https://7b8ff9c94262bf4a042eb62d75e09822@o4506308503273472.ingest.sentry.io/4506467088924672',
  hostName: 'https://dev.my.calenso.com',
  restAPI: '/api/v2/',
  authServiceHost: 'https://dev.auth.calenso.com',
  authServiceRestApiV1: '/api/',
  encryptedKey: 'dfk34Sfa$UzthV3sFs9S=fsla357UiTw$',
  imagePath: 'https://dev.my.calenso.com/files/workers/avatar/',
  partnersImagePath: 'https://dev.my.calenso.com/files/partners/logo/',
  deployUrl: 'https://signup.calenso.com',
  redirectDomain: 'https://calio.calenso.com',
  googleTagManagerCode: 'GTM-MJC5XGQ',
  recaptchaSiteKey: '6LfB5EchAAAAAMiJapMV9GumBAQBfKqboRWT5she',
  brandName: 'Calenso',
  customElementTag: 'calio-create-partner',
  defaultLocale: 'de_CH',
  region: 'eu',
  brandUrls: {
    BRAND_WEBSITE: 'https://www.calenso.com',
    BRAND_TERMS_URL: 'https://www.calenso.com/agb/',
    BRAND_PRIVACY_URL: 'https://www.calenso.com/datenschutz/',
    BRAND_SUPPORT_EMAIL: 'support@calenso.com',
    BRAND_THANK_YOU_URL: '',
  },
};
